import { useQuery } from '@tanstack/react-query';
import { getDailyExpandedReport } from 'services/auditService';
import { DailyReportModel } from 'models';

export function useDailyExpandedReport(storeId: string | null | undefined, date: string | null | undefined) {
    return useQuery<DailyReportModel | null, Error>({
        queryKey: ['daily-expanded-report', storeId, date],
        queryFn: () => getDailyExpandedReport(storeId!, date!),
        enabled: !!storeId && !!date
    });
}
